import { isDefined } from '@sgme/fp';

import type { BidAskRate } from '@/utils/number-point.ts';

type Parameters = {
  pinnedNearPrice: BidAskRate | undefined;
  spot: BidAskRate;
  nearDeltaRate: BidAskRate;
};

// NearPriceClientBid (Client Near price )
// =SI(PinNearPriceClientBid<>""
//   ;PinNearPriceClientBid
//   ;SpotPriceClientBid+NearPointsClientBid*10^-4)
export function computeNearPrice({ pinnedNearPrice, spot, nearDeltaRate }: Parameters): BidAskRate {
  if (isDefined(pinnedNearPrice)) {
    return pinnedNearPrice;
  }
  return {
    bid: spot.bid + nearDeltaRate.bid,
    ask: spot.ask + nearDeltaRate.ask,
  };
}
